<template>
  <div class="profile-page pa-5">
    <div class="d-flex align-center">
      <h3>User Profile</h3>
      <v-spacer />
      <v-btn
        class="ml-2"
        text
        tile
        x-large
        color="primary"
        @click="collaboratorBoundary.dialog = true"
      >
        {{ totalCollaborator }} Collaborators
      </v-btn>
    </div>

    <!-- Collaborators Dialog -->
    <v-dialog v-model="collaboratorBoundary.dialog">
      <v-card>
        <v-card-title class="secondary">
          Collaborators
          <v-spacer></v-spacer>
          <v-btn icon @click="collaboratorBoundary.dialog = false">
            <v-icon>
              clear
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-btn
            color="primary"
            depressed
            dark
            class="mb-2 mt-2"
            @click="invitationBoundary.dialog = true"
            tile
          >
            Invite Collaborator
          </v-btn>
          <v-data-table
            :headers="collaboratorBoundary.headers"
            :items="collaboratorBoundary.desserts"
          >
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="initialize">
                Reset
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Collaborators Dialog -->

    <!-- Invitation Dialog -->
    <v-dialog v-model="invitationBoundary.dialog" max-width="500px">
      <v-card>
        <v-card-title class="secondary">
          Invite Collaborator
          <v-spacer></v-spacer>
          <v-btn icon @click="invitationBoundary.dialog = false">
            <v-icon>
              clear
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-form
                  ref="invitationBoundaryForm"
                  v-model="invitationBoundary.valid"
                >
                  <!-- Email -->
                  <v-text-field
                    label="Email"
                    v-model="invitationBoundary.userId"
                    outlined
                    dense
                    type="email"
                  ></v-text-field>
                  <!-- Project -->
                  <v-select
                    v-model="invitationBoundary.projectId"
                    dense
                    outlined
                    :items="invitationBoundary.projectList"
                    @input="handleProjectSelect"
                    label="Project"
                  ></v-select>

                  <!-- Type -->
                  <v-text-field
                    label="Type"
                    v-model="invitationBoundary.type"
                    outlined
                    dense
                    type="text"
                  ></v-text-field>

                  <!-- Schedule-->
                  <v-select
                    v-model="invitationBoundary.selectedSchedule"
                    dense
                    outlined
                    :items="invitationBoundary.schedules"
                    label="Schedule"
                  ></v-select>

                  <v-btn
                    color="primary"
                    tile
                    @click="handleInvitationSendBtn"
                    :loading="invitationBoundary.loading"
                  >
                    Send
                  </v-btn>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Invitation Dialog -->

    <!-- Profile Details -->
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          hide-details
          label="First Name"
          type="text"
          v-model="userProfileBoundary.firstName"
          :rules="userProfileBoundary.rules.firstName"
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          hide-details
          label="Last Name"
          type="text"
          v-model="userProfileBoundary.lastName"
          :rules="userProfileBoundary.rules.lastName"
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          hide-details
          label="Email"
          type="text"
          v-model="userProfileBoundary.email"
          :rules="userProfileBoundary.rules.email"
          outlined
          dense
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          label="Password"
          type="password"
          v-model="userProfileBoundary.currentPassword"
          :rules="userProfileBoundary.rules.currentPassword"
          outlined
          dense
        ></v-text-field>

        <v-text-field
          label="Company Name"
          type="text"
          v-model="userProfileBoundary.companyName"
          :rules="userProfileBoundary.rules.companyName"
          outlined
          dense
        ></v-text-field>
      </v-col>

      <v-col>
        <v-select
          v-model="userProfileBoundary.type"
          :rules="userProfileBoundary.rules.type"
          :items="userProfileBoundary.roles"
          item-text="name"
          item-value="_id"
          label="Type"
          outlined
          no-data-text="No Role is found!"
          dense
        ></v-select>
      </v-col>
    </v-row>
    <v-btn tile dark color="grey darken-3" @click="updateProfile">Save</v-btn>
  </div>
</template>

<script>
import { roleService } from "@/services";
import { userApi, collaboratorApi, projectApi, scheduleApi } from "@/api";
export default {
  data() {
    return {
      totalCollaborator: 3,
      editedIndex: -1,
      editedItem: {
        name: "",
        email: "",
        companyName: "",
        type: "",
      },
      defaultItem: {
        name: "",
        email: "",
        companyName: "",
        type: "",
      },
      collaboratorBoundary: {
        dialog: false,
        headers: [
          {
            text: "Name",
            align: "start",
            sortable: false,
            value: "name",
          },
          { text: "Email", value: "email" },
          { text: "Company", value: "companyName" },
          { text: "Company Type", value: "type" },
          { text: "Actions", value: "actions", sortable: false },
        ],
        desserts: [
          {
            name: "Collaborator Name",
            email: "collaboratoremail@mail.com",
            companyName: "Company Name",
            type: "Some Comapny Type",
          },
          {
            name: "Collaborator Name",
            email: "collaboratoremail@mail.com",
            companyName: "Company Name",
            type: "Some Comapny Type",
          },
          {
            name: "Collaborator Name",
            email: "collaboratoremail@mail.com",
            companyName: "Company Name",
            type: "Some Comapny Type",
          },
        ],
      },
      invitationBoundary: {
        dialog: false,
        valid: true,
        userId: "",
        scheduleId: "",
        projectId: "",
        type: "",
        loading: false,
        projectList: [],
        schedules: [],
        selectedSchedule: null,
      },
      userProfileBoundary: {
        roles: roleService.allRole(),
        firstName: "",
        lastName: "",
        email: "",
        currentPassword: "",
        newPassword: "",
        companyName: "",
        type: "",
        rules: {
          firstName: [(v) => !!v || "First name is required"],
          lastName: [(v) => !!v || "Last name is required"],
          email: [(v) => !!v || "Email is required"],
          currentPassword: [(v) => !!v || "Current password is required"],
          newPassword: [(v) => !!v || "New password is required"],
          companyName: [(v) => !!v || "Company name is required"],
          type: [(v) => !!v || "Type is required"],
        },
      },
    };
  },
  computed: {},
  created() {
    let loader = this.$loading.show();
    let { email } = this.$store.getters.authUser;

    // Get user info
    userApi
      .getUser({
        email: email,
      })
      .then(({ data }) => {
        loader.hide();
        if (data.user) {
          this.userProfileBoundary.firstName = data.user.firstName;
          this.userProfileBoundary.lastName = data.user.lastName;
          this.userProfileBoundary.email = data.user.email;
          this.userProfileBoundary.companyName = data.user.company;
          this.userProfileBoundary.type = data.user.role;
        }
      })
      .catch((error) => {
        loader.hide();
        console.log(error);
      });

    // Fetch projects
    projectApi
      .getProject({
        offset: 1,
        size: 100,
      })
      .then(({ data }) => {
        data.data.forEach((item) => {
          this.invitationBoundary.projectList.push(item.projectName);
        });
      });
  },
  methods: {
    close() {},
    async handleProjectSelect() {
      let { email } = this.$store.getters.authUser;
      let projectId = this.invitationBoundary.projectId + "+" + email;
      try {
        let { data } = await scheduleApi.getByProjectId({
          projectId,
          offset: 1,
          size: 100,
          type: "default",
        });
        this.invitationBoundary.schedules = [];
        data.data.forEach((item) => {
          this.invitationBoundary.schedules.push(item.name);
        });
      } catch (error) {
        console.log(error);
      }
    },
    async handleInvitationSendBtn() {
      this.invitationBoundary.loading = true;
      try {
        const collaboratorApiResponse = await collaboratorApi.invite({
          projectId: this.invitationBoundary.projectId,
          scheduleId: this.invitationBoundary.scheduleId,
          userId: this.invitationBoundary.userId,
        });
      } catch ({ response }) {
        if (response.data.message) {
          this.$toast.error(response.data.message);
        }
      } finally {
        this.invitationBoundary.loading = false;
      }
    },

    updateProfile(){
      let { email } = this.$store.getters.authUser;
      try {
         userApi.editUser({
            email: email,
            data:this.userProfileBoundary
          });
          this.$toast.success("successfully updated.");
        } catch (error) {
          this.$toast.error(error.response.data.message);
        }
    }
  },
};
</script>

<style scoped>
h3 {
  color: #757575;
  font-size: 24px;
}
</style>
